export default __webpack_public_path__ + "static/jvc-osa-canada-30th-anniversary-book-cover-2619b7b54fe3e975b6f30fe4aab34d09.png";